import { COLOR1, ORIENTAL_D_GRAY } from '../../../constants';

export const MobileInputStyles = {
  area_code_input: {
    textAlign: 'left',
    // color: COLOR1,
    font: 'normal normal 300 14px/16px Arial',
    opacity: 1,
    height: '41px',
    letterSpacing: '0.1px',
    '& .MuiOutlinedInput-input': {
      padding: '11.5px 5px 11.5px 20px',
    },
    '& fieldset': {
      borderRadius: '2px',
      border: `0.5px solid ${ORIENTAL_D_GRAY}`,
    },
    '&::-webkit-input-placeholder': {
      opacity: 1,
    },
    '&::-moz-placeholder': {
      opacity: 1,
    },
    '&:-ms-input-placeholder': {
      opacity: 1,
    },
  },
};
